import { createHttpClient } from '@sd/shared';

export type RemoteVersionInfo = {
  gitSha: string;
  buildTimestamp: string;
};

const client = createHttpClient({ config: {} });
export const appVersionService = {
  async getRemoteVersionInfo() {
    return (await client.get<RemoteVersionInfo>('/version.json')).data;
  }
};
